import React from 'react';
import { CheckCircle, Wallet, ArrowUpRight } from 'lucide-react';
import './TransferSucessModal.scss';

export default function TransferSuccessModal({ 
  isOpen, 
  onClose, 
  onContinue,
  jobTitle,
  amount,
  freelancerName 
}) {
  if (!isOpen) return null;

  return (
    <div className="tsm-overlay" onClick={onClose}>
      <div className="tsm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="tsm-icon-wrapper">
          <div className="tsm-icon">
            <CheckCircle size={48} />
          </div>
        </div>

        <h2 className="tsm-title">🎉 Vaga Finalizada!</h2>
        
        <div className="tsm-message">
          <p className="tsm-text">
            O pagamento foi transferido com sucesso para a carteira do freelancer.
          </p>
        </div>

        <div className="tsm-details">
          <div className="tsm-detail-item">
            <span className="tsm-detail-label">Freelancer</span>
            <span className="tsm-detail-value">{freelancerName || '—'}</span>
          </div>
          <div className="tsm-detail-item">
            <span className="tsm-detail-label">Vaga</span>
            <span className="tsm-detail-value">{jobTitle || '—'}</span>
          </div>
          <div className="tsm-detail-item tsm-detail-item--highlight">
            <span className="tsm-detail-label">Valor transferido</span>
            <span className="tsm-detail-value tsm-detail-value--highlight">
              <Wallet size={16} />
              R$ {amount?.toFixed(2) || '0,00'}
            </span>
          </div>
        </div>

        <div className="tsm-actions">
          <button className="tsm-btn tsm-btn--primary" onClick={onContinue}>
            <ArrowUpRight size={18} />
            Continuar para avaliação
          </button>
        </div>

        <button className="tsm-later-btn" onClick={onClose}>
          Avaliar depois
        </button>
      </div>
    </div>
  );
}